import 'uvcanvas/dist/components/slides/default_components/styles.css';
import {
  Lumiflex,
  Zenitho,
  Novatrix,
  Velustro,
  Tranquiluxe,
  Opulento,
  Xenon,
  defaultComponents,
} from 'uvcanvas';

const { Background, Cover } = defaultComponents;

export {
  Lumiflex,
  Zenitho,
  Novatrix,
  Velustro,
  Tranquiluxe,
  Opulento,
  Xenon,
  Background,
  Cover,
};
